




import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'SkeletonShimmer',
  props: {
    width: {
      type: [String, Number],
      default: undefined,
      required: false,
    },
    height: {
      type: [String, Number],
      default: undefined,
      required: false,
    },
    borderRadius: {
      type: [String, Number],
      default: undefined,
      required: false,
    },
  },
});
